module.exports = __webpack_public_path__ + "img/hr-electric-mining-drill-S-drill-shadow.68b41695.png";